import axios from 'axios';
// const BASE_URL = 'https://api.soochi.in/api';
const BASE_URL = 'https://test.soochi.in/api';

//'http://localhost:3500';



export default axios.create({
    baseURL: BASE_URL
});

//for token
export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});